// extracted by mini-css-extract-plugin
export default {"size-xs":"styles_size-xs__kWU2e","size-sm":"styles_size-sm__daU39","size-md":"styles_size-md__qN7j0","size-lg":"styles_size-lg__9GrTU","size-xl":"styles_size-xl__h7M3d"};